


import apiClient from '../helpers/apiClient';
import { authHeader } from '../helpers/authHeader';


export const itemsSetupService = {
    getDropDownList,
    selectItemSetup,
    getFinishItemsDropDown,
    submitItemSetup,
    getProductionDropDown,
    getProductionSideTableData,
    getProductionItemprops,
    submitProduction,
    modifyProduction,
    getProductionHistory,
    getProdMasterdata,
    getCompositesGroupItems,
    getCompositesFormData,
    submitCompositeGroup,
    getItCompositeGroupImages,
    getCompositeInformation,
    getCompositeSellDetails,
    changeGroupStatus,
    compositesUploadImage,
    saveImageProperties,
    getAssociateItemsSelectList,
    submitAssociateItems
 
};




async function  getDropDownList() {
   return apiClient.get(`/get-item-setup-list`,  authHeader())
}

async function  getProductionDropDown() {
   return apiClient.get(`/get-production-dropdown`,  authHeader())
}

async function  getProductionSideTableData() {
   return apiClient.get(`/get-production-side-table-data`,  authHeader())
}


async function  getAssociateItemsSelectList() {
   return apiClient.get(`/get-associate-items-select-list`,  authHeader())
}


function submitProduction(xml_string, item_props){
   var body = {...xml_string, ...item_props}
  return apiClient.put('/submit-production', body, authHeader()); 
 }


function modifyProduction(id){
  return apiClient.get(`/modify-production/${id}`, authHeader()); 
 }


function getProductionHistory(body){
  return apiClient.put(`/get-production-history`,body,  authHeader()); 
 }

function getProdMasterdata(){
  return apiClient.get(`/get-production-master-data`,  authHeader()); 
 }


async function  getProductionItemprops(id) {
   return apiClient.get(`/get-production-item-props/${id}`,  authHeader())
}



async function  selectItemSetup(id) {
   return apiClient.get(`/select-item-setup/${id}`,  authHeader())
}



async function  getFinishItemsDropDown() {
   return apiClient.get(`/get-finish-item-drop-down`,  authHeader())
}


function submitItemSetup(xml_string, item_props){
   var body = {...xml_string, ...item_props}
  return apiClient.put('/submit-item-setup', body, authHeader()); 
 }

function getCompositesGroupItems(){
  return apiClient.get('/composites-group-items', authHeader()); 
 }

function getCompositesFormData(){
  return apiClient.get('/composites-select-list', authHeader()); 
 }

function submitCompositeGroup(data){
  return apiClient.post('/submit-composite-group',data,  authHeader()); 
 }
function submitAssociateItems(data){
  return apiClient.post('/submit-associate-items',data,  authHeader()); 
 }

 function getItCompositeGroupImages(group_id){
   return apiClient.get(`/get-composite-group-images/${group_id}`, authHeader())
 }

 function saveImageProperties(body){
   return apiClient.post(`/save-image-properties`,body, authHeader())
 }

 function compositesUploadImage(body){
   return apiClient.post(`/composite-image-upload`,body,  authHeader())
 }

 function getCompositeInformation(group_id){
   return apiClient.get(`/get-composite-group-data/${group_id}`, authHeader())
 }

 function getCompositeSellDetails(group_id){
   return apiClient.get(`/get-composite-sell-details/${group_id}`, authHeader())
 }

 function  changeGroupStatus( body){
   return apiClient.put(`/change-composite-group-status`, body, authHeader())
 }










